import React from 'react';
import { Citation } from '../../types/models';

interface UniqueCitation {
	file_id: string;
	file_name: string;
	citations: Citation[];
}

/** Deduplicates citations by file_id and returns grouped entries. */
export function deduplicateCitations(citations?: Citation[]): UniqueCitation[] {
	if (!citations || citations.length === 0) return [];

	const map = new Map<string, UniqueCitation>();
	citations.forEach((citation) => {
		const fileId = citation.source?.file_id ?? 'unknown';
		const fileName = citation.source?.file_name ?? 'Unknown File';

		if (!map.has(fileId)) {
			map.set(fileId, { file_id: fileId, file_name: fileName, citations: [citation] });
		} else {
			map.get(fileId)!.citations.push(citation);
		}
	});

	return Array.from(map.values());
}

interface CitationChipsProps {
	citations?: Citation[];
	onSelect: (citation: UniqueCitation) => void;
}

/** Renders deduplicated citation chips for an assistant message. */
export function CitationChips({ citations, onSelect }: CitationChipsProps) {
	const uniqueCitations = deduplicateCitations(citations);
	if (uniqueCitations.length === 0) return null;

	return (
		<div className="flex flex-wrap gap-2 my-2 mt-4">
			<div className="flex flex-wrap gap-2">
				{uniqueCitations.map((uc, idx) => (
					<div
						key={uc.file_id || idx}
						className="flex items-center gap-2 bg-zinc-700/65 text-white rounded-full px-3 py-1 text-sm font-medium hover:bg-zinc-700 cursor-pointer transition"
						onClick={() => onSelect(uc)}
					>
						<span className="bg-zinc-600 text-zinc-200 text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
							{idx + 1}
						</span>
						{uc.file_name}
					</div>
				))}
			</div>
		</div>
	);
}
